import { ExamSearchList } from './ExamSearchList';
export default ExamSearchList;
